import { SearchAction, SearchActionTypes } from '../../../../core/features/store/actions/search.actions';
import { DELIVERY_ADDRESS, DeliveryAddressSearchParamsState } from '../sold-to-state';

export const initialState: DeliveryAddressSearchParamsState = {
  key: undefined,
  count: 0,
  page: 0,
  text: '',
};

export function reducer(state = initialState, action: SearchAction): DeliveryAddressSearchParamsState {
  if (action.searchType !== DELIVERY_ADDRESS) {
    return state;
  }
  switch (action.type) {
    case SearchActionTypes.SearchAction:
      return action.searchParams;
    default:
      return state;
  }
}
